<template>
  <div
    class="field-wrapper-wuk sword-text-wuk"
    :class="{ 'sword-field-label-as-placeholder': labelAsPlaceholder, '--bg-fill': fillBg }"
  >

    <div class="label-and-before-input-wrapper">
      <slot name="label">
        <input-label
          v-if="label"
          :label="label"
          :style-type="labelStyle"
          :info-text="labelInfo"
          :required="required && showRequiredStar"
          :disabled="disabled"
          :label-as-placeholder="labelAsPlaceholder"
          :filled="filled"
          :invalid="invalidField"
          :for="uniqueId"
        />
      </slot>

      <slot name="before-input"></slot>
    </div>

    <base-input type="text"
                :name="name"
                :id="uniqueId"
                v-model="modelValue"
                class="sword-boxed-input-wuk"
                :required="required"
                :disabled="disabled"
                :placeholder="computedPlaceholder"
                :manual-error="manualError"
                v-bind="$attrs"
                @focus="$emit('focus', $event)"
                @blur="$emit('blur', $event)"
                :validation="validation" />
    <input-footer-wuk
      v-if="!hideErrors"
      :is-invalid="invalidField"
      :validator="validation"
      :manual-error="manualError"
      :help-text="helpText"
      :success-text="successText"
    />
  </div>
</template>

<script>
import inputHandler from '@ui-kit/mixins/inputHandler';
import BaseInput from '@ui-kit/components/inputs/BaseInput.vue';
import InputLabel from '@ui-kit/components/inputs/labels/InputLabel.vue';
import InputFooterWuk from '@ui-kit/components/inputs/footnotes/InputFooter.vue';

export default {
  name: 'SwordTextWuk',
  mixins: [inputHandler],
  components: {
    BaseInput,
    InputLabel,
    InputFooterWuk,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(check) {
        this.$emit('input', check);
      },
    },
  },
};
</script>
